import { render, staticRenderFns } from "./DownloadNote.vue?vue&type=template&id=507c7a38&scoped=true"
import script from "./DownloadNote.vue?vue&type=script&lang=js"
export * from "./DownloadNote.vue?vue&type=script&lang=js"
import style0 from "./DownloadNote.vue?vue&type=style&index=0&id=507c7a38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507c7a38",
  null
  
)

export default component.exports